import { createDecorator } from 'vue-class-component';

export const FunctionalComponent = createDecorator((options) => {
    (options as any).functional = true;
});



// WEBPACK FOOTER //
// ./src/decorators.ts